import {
  Component,
  Input,
  ContentChild,
  ViewEncapsulation
} from '@angular/core';
import { MdlTabPanelTitleComponent } from '../tabs/index';



export class MdlLayoutTabPanelComponent {

   public titleComponent;
   public title;
  public isActive = false;

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-layout-tab-panel',
  host: {
    '[class.mdl-layout__tab-panel]': 'true',
    '[class.is-active]': 'isActive'
  },
  template:
    `
   <ng-content *ngIf="titleComponent" select="mdl-tab-panel-content"></ng-content>
   <ng-content *ngIf="!titleComponent"></ng-content>
   `,
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'titleComponent': [{ type: ContentChild, args: [MdlTabPanelTitleComponent, ] },],
'title': [{ type: Input, args: ['mdl-layout-tab-panel-title', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
